<template lang="pug">
    .modal-overlay(v-if='show')
        .modal-content
            h3 Editar tipo de documento
            form(@submit.prevent='submitEdit')
                .form-group
                    label(for='nome') Nome:
                    input(type='text', v-model='document.nome', id='nome', required)
                .form-group
                    label(for='descricao') Descrição:
                    input(type='text', v-model='document.descricao', id='descricao', required)
                .form-group
                    label(for='ativo') Ativo:
                    input(type='checkbox', v-model='document.ativo', id='ativo')
                    span(v-if='document.ativo' style='color: var(--primary-green)')
                        i.fa.fa-check-circle
                        |  Ativo
                    span(v-else style='color: var(--primary-red)')
                        i.fa.fa-times-circle
                        |  Não Ativo
                .form-actions
                    .pull-left
                        button(type='button', @click='closeModal', style='margin-right: 290px')
                            i.fa.fa-times
                            |  Cancelar
                    .pull-right
                        button(type='submit', style='margin-left: 20px')
                            i.fa.fa-plus
                            |  Salvar


</template>

<script>
import { editarTiposDocumentos } from '@/services/tipo-documento.service';

export default {
    name: 'EditarDocumentoModal',
    props: {
        show: Boolean,
        document: Object
    },
    methods: {
        async submitEdit() {
            try {
                await editarTiposDocumentos(
                    this.document.id,
                    this.document.nome,
                    this.document.descricao,
                    this.document.ativo
                );
                this.$emit('update'); // Notifica o pai para recarregar os dados
                this.closeModal();
            } catch (error) {
                console.error('Erro ao editar tipo de documento:', error);
            }
        },
        closeModal() {
            this.$emit('close');
        }
    }
};
</script>

<style lang="scss" scoped>
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
    /* Garantir que o modal esteja sobre outros elementos */
}

.modal-content {
    background: #fff;
    padding: 20px;
    border-radius: 8px;
    width: 550px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.form-group {
    margin-bottom: 15px;

    label {
        display: block;
        margin-bottom: 5px;
        font-weight: bold;
    }

    input {
        width: 100%;
        padding: 8px;
        border: 1px solid #ccc;
        border-radius: 4px;
    }

    input[type='checkbox'] {
        width: auto;
        accent-color: var(--primary-green);
    }
}

.form-actions {
    display: flex;
    justify-content: space-between;

    button {
        padding: 10px 20px;
        border: none;
        border-radius: 4px;
        cursor: pointer;
        font-size: 14px;
    }
}

button[type='submit'] {
    background-color: var(--primary-green);
    color: #fff;
}

button[type='button'] {
    background-color: #ccc;
    color: #000;
}
</style>
